var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _rect, _g2, _rect2, _path9, _path10, _path11, _rect3, _path12, _path13, _path14, _rect4, _path15, _path16, _path17, _rect5, _path18, _path19, _path20, _rect6, _path21, _path22, _path23, _rect7, _path24, _path25, _path26, _rect8, _path27, _path28, _path29, _rect9, _path30, _path31, _path32, _rect10, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _rect11, _rect12, _path40, _path41, _g3, _path42, _circle, _g4, _path43, _rect13, _path44, _path45, _path46, _path47, _rect14, _path48, _path49, _path50, _path51, _path52, _rect15, _path53, _path54, _rect16, _rect17, _path55, _path56, _rect18, _rect19, _path57, _path58, _rect20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoSearchResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 517.74 441.33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m158.84 395.76a107 107 0 0 1 72.59 3l87.1 35.64a92.39 92.39 0 0 0 114.8-39l71.82-123.09a92.41 92.41 0 0 0 -18.27-115.41l-102.71-91.72a256.39 256.39 0 0 0 -181.08-64.97 211.51 211.51 0 0 0 -183.09 121.68 211.51 211.51 0 0 0 18.65 211.58l20 28.42a89.65 89.65 0 0 0 100.19 33.87z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m113.19 54h-10v325h157.5a7.5 7.5 0 0 1 7.5 7.5 7.5 7.5 0 0 0 7.5 7.5h25a7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 1 7.5-7.5h157.5v-325h-180l-4.88 12.5-5.12-12.5z",
    fill: "#111",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m118.19 49h-10v325h157.5a7.5 7.5 0 0 1 7.5 7.5 7.5 7.5 0 0 0 7.5 7.5h25a7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 1 7.5-7.5h157.5v-325h-180l-4.88 12.5-5.12-12.5z",
    fill: "#b9b9b9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m474.19 53v317h-153.5a11.51 11.51 0 0 0 -11.5 11.5 3.5 3.5 0 0 1 -3.5 3.5h-25a3.5 3.5 0 0 1 -3.5-3.5 11.51 11.51 0 0 0 -11.5-11.5h-153.5v-317h173.31l4.11 10 3.8 9.25 3.59-9.25 3.92-10zm4-4h-180l-4.88 12.5-5.12-12.5h-180v325h157.5a7.5 7.5 0 0 1 7.5 7.5 7.5 7.5 0 0 0 7.5 7.5h25a7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 1 7.5-7.5h157.5z",
    fill: "#868686"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m293.19 389v-325a25 25 0 0 0 -25-25h-150v325h150a25 25 0 0 1 25 25z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m293.19 389v-325a25 25 0 0 1 25-25h150v325h-150a25 25 0 0 0 -25 25z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m283.19 44v325a25 25 0 0 1 10 20v-325a25 25 0 0 0 -10-20z",
    fill: "#ececec"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m303.19 44v325a25 25 0 0 0 -10 20v-325a25 25 0 0 1 10-20z",
    fill: "#ececec"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m293.19 389.02v-325",
    stroke: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#272727"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m293.19 64a25 25 0 0 0 -25-25h-150v325h150a25 25 0 0 1 25 25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m293.19 64a25 25 0 0 1 25-25h150v325h-150a25 25 0 0 0 -25 25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.69 374h12.5a15 15 0 0 1 15 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.36 374h-12.17a15 15 0 0 0 -15 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.19 49h-10v325h157.5a7.5 7.5 0 0 1 7.5 7.5 7.5 7.5 0 0 0 7.5 7.5h25a7.5 7.5 0 0 0 7.5-7.5 7.5 7.5 0 0 1 7.5-7.5h157.5v-325h-10"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 40,
    rx: 20,
    width: 40,
    x: 133.19,
    y: 61.52
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ececec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m183.19 61.52h85v5h-85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.19 96.52h60v5h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.19 71.52h35v5h-35z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 40,
    rx: 20,
    width: 40,
    x: 133.19,
    y: 121.52
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m183.19 121.52h60v5h-60z",
    fill: "#ececec"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m183.19 156.52h40v5h-40z",
    fill: "#ececec"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m183.19 131.52h35v5h-35z",
    fill: "#ececec"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 40,
    rx: 20,
    width: 40,
    x: 133.19,
    y: 181.52
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m183.19 181.52h75v5h-75z",
    fill: "#ececec"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m183.19 216.52h25v5h-25z",
    fill: "#ececec"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m183.19 191.52h55v5h-55z",
    fill: "#ececec"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 40,
    rx: 20,
    width: 40,
    x: 133.19,
    y: 241.52
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m183.19 241.52h35v5h-35z",
    fill: "#ececec"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m183.19 276.52h45v5h-45z",
    fill: "#ececec"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m183.19 251.52h55v5h-55z",
    fill: "#ececec"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 40,
    rx: 20,
    width: 40,
    x: 133.19,
    y: 301.52
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m183.19 301.52h65v5h-65z",
    fill: "#ececec"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m183.19 336.52h50v5h-50z",
    fill: "#ececec"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m183.19 311.52h15v5h-15z",
    fill: "#ececec"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 40,
    rx: 20,
    width: 40,
    x: 312.86,
    y: 61.52
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 61.52h65v5h-65z",
    fill: "#ececec"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 96.52h75v5h-75z",
    fill: "#ececec"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 71.52h25v5h-25z",
    fill: "#ececec"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 40,
    rx: 20,
    width: 40,
    x: 312.86,
    y: 121.52
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 121.52h85v5h-85z",
    fill: "#ececec"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 156.52h60v5h-60z",
    fill: "#ececec"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 131.52h35v5h-35z",
    fill: "#ececec"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 40,
    rx: 20,
    width: 40,
    x: 312.86,
    y: 181.52
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 181.52h60v5h-60z",
    fill: "#ececec"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 216.52h40v5h-40z",
    fill: "#ececec"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 191.52h35v5h-35z",
    fill: "#ececec"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 40,
    rx: 20,
    width: 40,
    x: 312.86,
    y: 241.52
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 241.52h75v5h-75z",
    fill: "#ececec"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 276.52h25v5h-25z",
    fill: "#ececec"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 251.52h55v5h-55z",
    fill: "#ececec"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 40,
    rx: 20,
    width: 40,
    x: 312.86,
    y: 301.52
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 301.52h35v5h-35z",
    fill: "#ececec"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 336.52h45v5h-45z",
    fill: "#ececec"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m362.86 311.52h55v5h-55z",
    fill: "#ececec"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m392.12 386.57-6.39-6.46a6 6 0 0 0 -8.3-8.4l-79.55-80.54a6 6 0 0 0 -8.29-8.39l-6.4-6.48a11 11 0 0 0 -15.56-.09l-1.06 1.05-26.77-27.09a6 6 0 0 0 -4.83-9.51 5.7 5.7 0 0 0 -1.49.2 101 101 0 0 0 -80.61-161.11h-.64a101 101 0 0 0 -.6 202h.64a100.23 100.23 0 0 0 59.12-19.11 6 6 0 0 0 5.72 7.59 5.91 5.91 0 0 0 3.44-1.09l26.77 27.1-1.07 1.05a11 11 0 0 0 -.09 15.56l6.39 6.47a6 6 0 0 0 4.82 9.5 5.92 5.92 0 0 0 3.44-1.1l79.54 80.52a6 6 0 0 0 4.83 9.5 5.93 5.93 0 0 0 3.44-1.09l6.38 6.47a11 11 0 0 0 7.76 3.27h.24a10.93 10.93 0 0 0 7.73-3.18l21.27-21.08a11 11 0 0 0 .12-15.56z",
    fill: "#111",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m95.76 108.5a87.66 87.66 0 0 0 -12.57 15.67v93.16a87.49 87.49 0 1 0 12.57-108.83z",
    fill: "#b9b9b9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m97.4 107v127.6a87.49 87.49 0 1 0 0-127.6z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m83.19 217.33c1.24 2 2.58 3.92 4 5.81v-104.81c-1.43 1.9-2.75 3.85-4 5.84z",
    fill: "#868686"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 56.86,
    rx: 28.43,
    width: 56.86,
    x: 118.73,
    y: 92.53
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 56.86,
    rx: 28.43,
    width: 56.86,
    x: 118.73,
    y: 177.82
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m96.4 233.59c.67.64 1.32 1.29 2 1.91v-129.5c-.67.61-1.34 1.24-2 1.87z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m82.19 215.71c.64 1.07 1.3 2.14 2 3.19v-96.31c-.69 1-1.36 2.09-2 3.16z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ececec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m196.47 92.53h-6.67v7.11h18.42a87.46 87.46 0 0 0 -11.75-7.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.5 109.26c-.85-.87-1.73-1.69-2.61-2.51h-27.09v7.11h33.9c-1.34-1.57-2.7-3.11-4.2-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 142.29h-50.2v7.1h52.3c-.6-2.39-1.28-4.76-2.1-7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.44 177.82h-54.64v7.11h53.78c.42-2.36.67-4.73.86-7.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.13 192h-52.33v7.11h50.2q1.23-3.48 2.13-7.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.8 227.58v7.1h27.2c.6-.56 1.2-1.1 1.79-1.68 1.77-1.75 3.43-3.57 5-5.42z"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m157.25 83.25v4a83.49 83.49 0 1 1 -58.68 24.09 82.87 82.87 0 0 1 58.68-24.09zm0 0a87.5 87.5 0 1 0 62.25 26 87.18 87.18 0 0 0 -62.25-26z",
    opacity: 0.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.25,
    cy: 170.75,
    fill: "#ececec",
    opacity: 0.5,
    r: 87
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m149.28 87.91a83.24 83.24 0 0 0 -74.76 73.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.1 90.15-101.7 100.46a82.73 82.73 0 0 0 21.65 38.62 84.29 84.29 0 0 0 14.3 11.59l115.5-114.1a83.3 83.3 0 0 0 -49.75-36.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.74 254a83.14 83.14 0 0 0 83-93.55l-93.91 92.76a83.55 83.55 0 0 0 10.91.79z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m232.6 234.68h25v50h-25z",
    fill: "#dbdbdb",
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -111.76 247.18)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    fill: "#aaa",
    height: 175,
    rx: 10,
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -145.19 325.84)",
    width: 50,
    x: 299.16,
    y: 252.21
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m371.51 401.87-108.93-110.27a10 10 0 0 1 .09-14.14l-10.67 10.54a10 10 0 0 0 -.08 14.14l108.92 110.27a10 10 0 0 0 14.14.09l10.67-10.5a10 10 0 0 1 -14.14-.13z",
    fill: "#777"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m280.36 274 108.93 110.3a10 10 0 0 1 -.08 14.15l7.11-7a10 10 0 0 0 .09-14.14l-108.93-110.31a10 10 0 0 0 -14.14-.09l-7.12 7a10 10 0 0 1 14.14.09z",
    fill: "#ddd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m235.12 240.82h7.5v50h-7.5z",
    fill: "#a7a7a7",
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -117.88 244.58)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m247.57 228.53h7.5v50h-7.5z",
    fill: "#f3f3f3",
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -105.64 249.78)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 175,
    rx: 10,
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -145.19 325.84)",
    width: 50,
    x: 299.16,
    y: 252.21
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m236.42 233.11 35.14 35.57",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m218.63 250.67 35.14 35.58",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m87 99.61a100 100 0 1 0 141.42.86 100 100 0 0 0 -141.42-.86zm131.74 133.39a87.5 87.5 0 1 1 .76-123.74 87.5 87.5 0 0 1 -.76 123.74z",
    fill: "#a7a7a7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m157.25 83.25a87.5 87.5 0 1 1 -61.49 25.25 87.23 87.23 0 0 1 61.49-25.25m0-6a93.5 93.5 0 1 0 66.52 27.75 93 93 0 0 0 -66.52-27.79z",
    fill: "#dbdbdb"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m87 99.61a100 100 0 1 0 141.42.86 100 100 0 0 0 -141.42-.86zm131.74 133.39a87.5 87.5 0 1 1 .76-123.74 87.5 87.5 0 0 1 -.76 123.74z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 10,
    rx: 5,
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -126.62 282.14)",
    width: 60,
    x: 250.23,
    y: 290.25
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m261 304.3h15a0 0 0 0 1 0 0v10a0 0 0 0 1 0 0h-15a5 5 0 0 1 -5-5 5 5 0 0 1 5-5z",
    fill: "#a7a7a7",
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -140.61 276.2)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m293.74 274.43h10a0 0 0 0 1 0 0v10a0 0 0 0 1 0 0h-10a5 5 0 0 1 -5-5 5 5 0 0 1 5-5z",
    fill: "#f3f3f3",
    transform: "matrix(-.71141303 .70277415 -.70277415 -.71141303 703.37 270.04)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 10,
    rx: 5,
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -126.62 282.14)",
    width: 60,
    x: 250.23,
    y: 290.25
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 10,
    rx: 5,
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -105.82 233.2)",
    width: 35,
    x: 213.54,
    y: 240.45
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m237.79 232.54h7.5a0 0 0 0 1 0 0v10a0 0 0 0 1 0 0h-7.5a5 5 0 0 1 -5-5 5 5 0 0 1 5-5z",
    fill: "#f3f3f3",
    transform: "matrix(-.71141303 .70277415 -.70277415 -.71141303 576.04 238.54)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m221.79 248.35h7.5a0 0 0 0 1 0 0v10a0 0 0 0 1 0 0h-7.5a5 5 0 0 1 -5-5 5 5 0 0 1 5-5z",
    fill: "#a7a7a7",
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -113.68 229.86)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 10,
    rx: 5,
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -105.82 233.2)",
    width: 35,
    x: 213.54,
    y: 240.45
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dbdbdb",
    height: 10,
    rx: 5,
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -163.76 369.54)",
    width: 60,
    x: 338.08,
    y: 379.17
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m348.85 393.23h15a0 0 0 0 1 0 0v10a0 0 0 0 1 0 0h-15a5 5 0 0 1 -5-5 5 5 0 0 1 5-5z",
    fill: "#a7a7a7",
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -177.75 363.59)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m381.59 363.36h10a0 0 0 0 1 0 0v10a0 0 0 0 1 0 0h-10a5 5 0 0 1 -5-5 5 5 0 0 1 5-5z",
    fill: "#f3f3f3",
    transform: "matrix(-.71141303 .70277415 -.70277415 -.71141303 916.21 360.5)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 10,
    rx: 5,
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    transform: "matrix(.71141303 -.70277415 .70277415 .71141303 -163.76 369.54)",
    width: 60,
    x: 338.08,
    y: 379.17
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResults);
export default __webpack_public_path__ + "static/media/no_search_results.0467e225539f00afbedf5dfb1f6bfb18.svg";
export { ForwardRef as ReactComponent };